function Reflection() {
  return (
    <section className="w-full mb-16 font-DM" id="Reflection">
      <h1 className="font-DM text-pinkie uppercase mb-6">Reflection</h1>
      <div className="grid grid-cols-2 gap-x-10">
        <p className="font-DM">
          Through this hackathon, I was able to work with people in this field
          with different experiences and gained new understandings.
          Additionally, we worked with a mentor that taught us many things
          throughout the process, such as how to conduct research and ideate
          more creatively.
        </p>
        <p className="font-DM">
          The time constraints of a one-week project forced us to work at a
          rapid pace, limiting our time for extensive decision-making and
          experimentation. However, this taught me how to work with my team to
          quickly come to a decision together and work efficiently.
        </p>
      </div>
    </section>
  );
}

export default Reflection;
